import React from "react";
import Masonry from "react-masonry-css";
import { Link } from "react-router-dom";
import "./Design.css";

import threeFold01 from "../../assets/design/threeFold/threeFold01.jpg";
import mooncake01 from "../../assets/design/mooncake/mooncake01.jpg";
import kemooMain from "../../assets/design/kemoo/kemooMain.jpg";
import logo01 from "../../assets/design/logoDesign/logo01.jpg";
import egg from "../../assets/design/egg/egg.jpg";

const collections = [
    { id: 1, title: "可沐蔬果", image: kemooMain, count: 8 },
    { id: 2, title: "三折頁設計", image: threeFold01, count: 2 },
    { id: 3, title: "月餅禮盒", image: mooncake01, count: 2 },
    { id: 4, title: "am logo design", image: logo01, count: 2 },
    { id: 5, title: "皮蛋", image: egg, count: 1 },
];
const breakpointColumnsObj = {
    default: 3,
    1100: 2,
    700: 1,
};

const Design = () => {
    return (
        <div className="design-container">
            <Masonry
                breakpointCols={breakpointColumnsObj}
                className="masonry-grid"
                columnClassName="masonry-grid_column"
            >
                {collections.map((item, index) => (
                    <Link
                        to={`/design-detail/${item.id}`}
                        className="design-item"
                        key={item.id}
                        style={{ animationDelay: `${index * 0.1}s` }}
                    >
                        {/* <div className="image-wrapper">
                            <img src={item.image} alt={item.title} loading="lazy" />
                            <div className="overlay">
                                <h3>{item.title}</h3>
                            </div>
                        </div> */}
                        <div className="image-wrapper">
                            <img src={item.image} alt={item.title} loading="lazy" />
                        </div>
                    </Link>
                ))}
            </Masonry>
        </div>
    );
};

export default Design;














// import React from "react";
// import { Box, Typography } from "@mui/material";
// import { keyframes } from "@mui/system";
// import bee from "../../assets/bee.gif";
// import bear from "../../assets/bear.gif";
// import star from "../../assets/star.gif";

// const fadeIn = keyframes`
//   from { opacity: 0; }
//   to { opacity: 1; }
// `;

// const works = [
//     { id: 1, title: "Bee Animation", img: bee },
//     { id: 2, title: "Bear Animation", img: bear },
//     { id: 3, title: "Star Animation", img: star },
//     { id: 4, title: "Another Bee", img: bee },
//     { id: 5, title: "Another Bear", img: bear },
//     { id: 6, title: "Another Star", img: star },
// ];

// const Design = () => {
//     return (
//         <Box
//             sx={{
//                 marginTop: "20px",
//                 padding: "100px",
//                 animation: `${fadeIn} 0.3s ease-in`,
//                 maxWidth: "1200px",
//                 marginLeft: "auto",
//                 marginRight: "auto",
//             }}
//         >
//             <Box
//                 sx={{
//                     display: "grid",
//                     gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
//                     gap: "20px",
//                     justifyContent: "center",
//                 }}
//             >
//                 {works.map((work) => (
//                     <Box
//                         key={work.id}
//                         sx={{
//                             display: "flex",
//                             flexDirection: "column",
//                             alignItems: "center",
//                             textAlign: "center",
//                         }}
//                     >
//                         <Box
//                             sx={{
//                                 width: "100%",
//                                 height: "200px", // Ensures images have the same height
//                                 display: "flex",
//                                 alignItems: "center",
//                                 justifyContent: "center",
//                                 borderRadius: "10px",
//                                 overflow: "hidden",
//                                 backgroundColor: "#f5f5f5",
//                             }}
//                         >
//                             <img
//                                 src={work.img}
//                                 alt={work.title}
//                                 style={{
//                                     width: "100%",
//                                     height: "100%",
//                                     objectFit: "cover", // Keeps aspect ratio while filling the space
//                                     borderRadius: "10px",
//                                     display: "block",
//                                 }}
//                             />
//                         </Box>
//                         <Typography
//                             variant="h6"
//                             sx={{
//                                 marginTop: "10px",
//                                 fontSize: "14px",
//                                 fontWeight: "bold",
//                                 color: "#333",
//                             }}
//                         >
//                             {work.title}
//                         </Typography>
//                     </Box>
//                 ))}
//             </Box>
//         </Box>
//     );
// };

// export default Design;
